import React, { useMemo } from "react";
import { makeStyles } from "@mui/styles";
import Tab from "@mui/material/Tab";
import Tabs from "./Tabs";
import "./style.scss";
import { _Enum_Trang_Thai_Noi_Dung } from "../../../../action/defaultEnums";
import { Typography, Box } from "@mui/material";

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const Vertical = (props) => {
  // props
  const { children, tabs, height, tabWidth, onClick, value, ...attribute } =
    props;
  // Styled
  const useStyles = makeStyles((theme) => ({
    root: {
      height,
      flexGrow: 1,
      backgroundColor: "#f8fafc",
      display: "flex",
    },
    tab: {
      maxWidth: "inherit",
      width: "100%",
      alignItems: "flex-start",
      textTransform: "none",
      padding: "12px 16px",
      minHeight: "auto",
      borderLeft: "3px solid transparent",
      borderRadius: "0.5rem",
      transition: "all 0.2s ease",
      "&.Mui-selected": {
        backgroundColor: "#eff6ff",
        borderLeftColor: "#3b82f6",
      },
      "&:hover": {
        backgroundColor: "#f1f5f9",
      },
    },
    tabContent: {
      width: "100%",
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
    },
    tabInfoWrapper: {
      flex: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
    },
    indexCircle: {
      minWidth: "28px",
      height: "28px",
      borderRadius: "50%",
      backgroundColor: "#e5e7eb",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "13px",
      fontWeight: 600,
      color: "#374151",
      flexShrink: 0,
    },
    indexCircleActive: {
      backgroundColor: "#3b82f6",
      color: "#ffffff",
    },
    tabInfo: {
      flex: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
    },
    tabTitle: {
      fontSize: "14px",
      fontWeight: 500,
      color: "#1f2937",
      lineHeight: 1.4,
      textAlign: "left",
      // CSS line-clamp for 2 lines with ellipsis
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
      wordBreak: "break-word",
    },
    tabTime: {
      fontSize: "12px",
      color: "#6b7280",
      marginTop: "4px",
      flexShrink: 0,
    },
    badgeContainer: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginTop: "6px",
      flexWrap: "wrap",
      justifyContent: "flex-end",
    },
    durationBadge: {
      fontSize: "11px",
      fontWeight: 500,
      backgroundColor: "white",
      color: "#4b5563",
      padding: "2px 8px",
      borderRadius: "4px",
      display: "inline-block",
    },
    statusBadge: {
      fontSize: "11px",
      fontWeight: 500,
      backgroundColor: "#dbeafe",
      color: "#1d4ed8",
      padding: "2px 8px",
      borderRadius: "4px",
      display: "inline-block",
    },
  }));
  // classes
  const classes = useStyles();

  const formatTime = (datetime) => {
    if (!datetime) return "";
    const date = new Date(datetime);
    return date.toLocaleTimeString("vi-VN", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const renderTabs = useMemo(() => {
    return (
      <Tabs
        width={tabWidth}
        title="Nội dung phiên họp"
        value={value}
        {...attribute}
      >
        {tabs.map((tab, index) => {
          const isActive = value === index + 1;
          const isDangHop = tab.trangThai === _Enum_Trang_Thai_Noi_Dung.DangHop;

          return (
            <Tab
              className={classes.tab}
              value={index + 1}
              key={"nd" + index}
              onClick={() => onClick({ activeTab: index + 1, id: tab.id })}
              label={
                <Box className={classes.tabContent}>
                  <Box
                    className={`${classes.indexCircle} ${isDangHop ? classes.indexCircleActive : ""}`}
                  >
                    {String(index + 1).padStart(2, "0")}
                  </Box>
                  <Box className={classes.tabInfoWrapper}>
                    <Box className={classes.tabInfo}>
                      <Typography className={classes.tabTitle}>
                        {tab.noiDung}
                      </Typography>
                      {/* Time display - show range if both times exist */}
                      {tab.batDau && tab.ketThuc && (
                        <Typography className={classes.tabTime}>
                          {formatTime(tab.batDau)} - {formatTime(tab.ketThuc)}
                        </Typography>
                      )}

                      {/* For active items OR items without ketThuc, show badge */}
                      <Box className={classes.badgeContainer}>
                        <Box className={classes.durationBadge}>
                          {tab.thoiLuong
                            ? `${tab.thoiLuong} phút`
                            : "Dự tính 15 phút"}
                        </Box>
                        {isDangHop && (
                          <Box className={classes.statusBadge}>
                            Đang trình bày
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              }
              {...a11yProps(index)}
            />
          );
        })}
      </Tabs>
    );
  }, [attribute, classes, onClick, tabWidth, tabs, value]);

  return (
    tabs && (
      <div className={classes.root}>
        {renderTabs}
        {children}
      </div>
    )
  );
};

export default Vertical;
